import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, ValidationErrors, Validators} from '@angular/forms';
import {forbiddenCharactersValidator} from '@iv/shared/validators/forbidden-characters-validator';
import {InputTooltipComponent} from '@iv/shared/components/input-tooltip/input-tooltip.component';
import {alreadyExistsValidator} from '@iv/shared/validators/already-exists-validator';
import {Group} from '@iv/model/group';
import {onlyWhitespaceValidator} from '@iv/shared/validators/only-whitespace-validator';
import {removeExtraSpaces} from '@iv/shared/helpers/common.helper';

@Component({
  selector: 'iv-live-group-creation-popup-content',
  templateUrl: './group-creation-popup-content.component.html',
  styleUrls: ['./group-creation-popup-content.component.css']
})
export class GroupCreationPopupContentComponent implements OnChanges, OnInit {
  @ViewChild('inputTooltip') inputTooltip: InputTooltipComponent;

  @Input() serviceName: string;
  @Input() existingGroups: Group[];

  @Output() closePopup: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() applyName = new EventEmitter<{ name: string, toggleLoading: () => void }>();

  form: FormGroup;
  loading = false;

  constructor(private fb: FormBuilder) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.existingGroups) {
      this.form?.get('groupName').setValidators([
        Validators.required,
        Validators.maxLength(20),
        forbiddenCharactersValidator(),
        onlyWhitespaceValidator(),
        alreadyExistsValidator(this.existingGroups)
      ]);

      this.form?.get('groupName').updateValueAndValidity();
    }
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      groupName: [
        '',
        [
          Validators.required,
          Validators.maxLength(20),
          forbiddenCharactersValidator(),
          onlyWhitespaceValidator(),
          alreadyExistsValidator(this.existingGroups)
        ]
      ]
    });

    this.form.get('groupName').valueChanges.subscribe(name => {
      this.form.get('groupName').setValue(removeExtraSpaces(name), {emitEvent: false});
      this.form.valid ? this.inputTooltip.hide() : this.inputTooltip.show(this.getFirstErrorMessage(this.form.get('groupName').errors));
    });
  }

  getFirstErrorMessage(errors: ValidationErrors): string {
    const [firstError, errorDetails] = Object.entries(errors)[0];

    switch (firstError) {
      case 'required': return 'A group name can\'t be empty';
      case 'maxlength' : return `A group name can't contain more the ${errorDetails.requiredLength} characters`;
      case 'forbiddenCharacters' : return 'A group name can\'t contain any of the following characters: / \\ : * ? " < > |';
      case 'onlyWhitespace' : return 'A group name can\'t contain only whitespaces';
      case 'alreadyExists' : return 'A group with this name is already exist';
      default: return 'Invalid group name, please use another';
    }
  }

  toggleLoading = () => {
    this.loading = !this.loading;
  }

  applyGroupName() {
    this.applyName.emit({
        name: this.form.get('groupName').value.trim(),
        toggleLoading: this.toggleLoading,
      }
    );

    this.toggleLoading();
  }

  close() {
    this.closePopup.emit(true);
  }
}
